export const CHANGE_PHYSICAL_PERSON_DATA = 'CHANGE_PHYSICAL_PERSON_DATA';
export type CHANGE_PHYSICAL_PERSON_DATA = typeof CHANGE_PHYSICAL_PERSON_DATA;


// WEBPACK FOOTER //
// ./src/actions/physical-person/change-data/Types.tsx